import store from '../store';
import Incoming from '../views/warehouse/Incoming.vue';
import Outcoming from '../views/warehouse/Outcoming.vue';
import Detail from '../views/warehouse/Detail.vue';
import Inventory from '../views/warehouse/Inventario.vue';
import Ddt from '../views/warehouse/Ddt.vue';
const DdtCreate = () => import('../views/warehouse/DdtCreate.vue');
import Cashout from '../views/warehouse/Cashout.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/warehouse/incoming',
		name: 'incoming',
		component: Incoming,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/warehouse/outcoming',
		name: 'outcoming',
		component: Outcoming,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/warehouse/detail',
		name: 'detail',
		component: Detail,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/warehouse/inventory',
		name: 'detail',
		component: Inventory,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/warehouse/ddt',
		name: 'ddt',
		component: Ddt,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	// aggiunta a mano di un prodotto al DDT: pagina, non piu' finestra della lista
	{
		path: '/warehouse/ddt/new',
		name: 'ddt-new',
		component: DdtCreate,
		beforeEnter(to, from, next) {
			checkauth().then(response => (response ? next() : next('/login')));
		},
	},
	{
		path: '/warehouse/cashout',
		name: 'cashout',
		component: Cashout,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
